// extracted by mini-css-extract-plugin
module.exports = {"highTopMargin":"tp","lowTopMargin":"tq","rightColumnWrapper":"tr","rightColumnTitle":"ts","title":"tt"};